<template>
    <div class="bg-0A1129 text-white">
        <Mainlayout />
    
        <section class="hero-section text-light text-center py-5">
            <h1 class="display-4 font-weight-bold mb-3 mt-5 noselect">Ulasan Kata untuk Fly High</h1>
    
            <p class="custom-16px-400 text-white font-inter">Mari mendengar pengalaman mereka yang sudah bergabung dengan Fly-High.</p>
            <CRow class="mt-5">
                <img src="../assets/img/flyhigh/feedback.png" style="max-width:100%;" />
    
            </CRow>
    
            <CContainer class="mt-5">
                <br /><br />
                <CRow>
                    <CCol sm="8">
                        <div class="text-left">
                            <h3 class="custom-32px-500">Bertemu dengan calon terbaik kami</h3>
                            <p class="custom-20px-400">Berikut adalah perkongsian pengalaman sebenar daripada pelajar dan ibu bapa FlyHigh yang berpuas hati dengan hasil pembelajaran mereka.</p>
    
                        </div>
    
                    </CCol>
                    <CCol sm="4">
                        <h4 class="custom-40px-700">100%</h4>
                        <p class="custom-20px-400">Pelajar Berjaya</p>
                    </CCol>
    
                    <CRow class="mt-5">
                        <CCol sm="4" style="border-left: 1px solid rgba(255, 255, 255, 0.18);">
                            <h3 class="text-left custom-18px-400 text-white">FlyHigh adalah rakan yang luar biasa untuk meningkatkan keahlian dan kemahiran pasukan Strategi Pemasaran</h3>
                            <CRow>
                                <CCol sm="3">
                                    <img src="../assets/img/flyhigh/circle-grey.png" style="max-width:100%" />
                                </CCol>
                                <CCol sm="9" class="text-left">
                                    <h3 class="custom-14px-700 mt-2">Tie Suha</h3>
                                    <p class="custom-14px-400">Parents</p>
                                </CCol>
                            </CRow>
                        </CCol>
                        <CCol sm="4" style="border-left: 1px solid rgba(255, 255, 255, 0.18);">
                            <h3 class="text-left custom-18px-400 text-white">Alhamdulillah. Terima kasih Ustaz Abi. Terima kasih Fly High Education Centre. Road to Mumtaz PSRA pula!</h3>
                            <CRow>
                                <CCol sm="3">
                                    <img src="../assets/img/flyhigh/circle-grey.png" style="max-width:100%" />
                                </CCol>
                                <CCol sm="9" class="text-left">
                                    <h3 class="custom-14px-700 mt-2">Insyirah Nuusyrah Buusyrah</h3>
                                    <p class="custom-14px-400">Parents</p>
                                </CCol>
                            </CRow>
                        </CCol>
                        <CCol sm="4" style="border-left: 1px solid rgba(255, 255, 255, 0.18);">
                            <h3 class="text-left custom-18px-400 text-white">Tq FlyHigh berkongsi ilmu dan tips menarik.. especially admin Lya dan Ustaz Abi cool sokmo layan kerenah anak2 online. Muh</h3>
                            <CRow>
                                <CCol sm="3">
                                    <img src="../assets/img/flyhigh/circle-grey.png" style="max-width:100%" />
                                </CCol>
                                <CCol sm="9" class="text-left">
                                    <h3 class="custom-14px-700 mt-2">Tie Suha</h3>
                                    <p class="custom-14px-400">Parents</p>
                                </CCol>
                            </CRow>
                        </CCol>
    
                    </CRow>
                    <CRow class="mt-3">
                        <CCol sm="4" style="border-left: 1px solid rgba(255, 255, 255, 0.18);">
                            <h3 class="text-left custom-18px-400 text-white">Alhamdulillah, anak saya Nur Chinta Elfiera dari Sibu, Sarawak berjaya mendapat 8A dalam UPKK 2023/2024. Terima kasih F</h3>
                            <CRow>
                                <CCol sm="3">
                                    <img src="../assets/img/flyhigh/circle-grey.png" style="max-width:100%" />
                                </CCol>
                                <CCol sm="9" class="text-left">
                                    <h3 class="custom-14px-700 mt-2">Haslizawati Md Akhir</h3>
                                    <p class="custom-14px-400">Parents</p>
                                </CCol>
                            </CRow>
                        </CCol>
    
                        <CCol sm="4" style="border-left: 1px solid rgba(255, 255, 255, 0.18);">
                            <h3 class="text-left custom-18px-400 text-white">Alhamdulillah syukur kepada Allah, anak dapat keputusan cemerlang.. terima kasih KPD semuat team..</h3>
                            <CRow>
                                <CCol sm="3">
                                    <img src="../assets/img/flyhigh/circle-grey.png" style="max-width:100%" />
                                </CCol>
                                <CCol sm="9" class="text-left">
                                    <h3 class="custom-14px-700 mt-2">Haslizawati Md Akhir</h3>
                                    <p class="custom-14px-400">Parents</p>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
    
                </CRow>
            </CContainer>
            <div style="width:95%;margin:0 auto">
                <br /> <br />
                <h1 class="display-4 font-weight-bold mb-3 mt-5 noselect gradient-text">
                    Temui pelajar-pelajar terbaik kami dan <br /> kisah FlyHigh mereka.
                </h1>
    
                <p class="custom-16px-400 text-white font-inter">Dari usaha keras kepada keputusan cemerlang lihat bagaimana pelajar FlyHigh meninggalkan jejak mereka dalam peperiksaan kebangsaan.</p>
    
    
                <CRow class="mt-4">
                    <CCol sm="3" v-for="(img, index) in images" :key="index" class="p-2">
                        <img :src="img.src" style="max-width:100%; cursor: pointer;" @click="openPopup(img)" />
                    </CCol>
                </CRow>
    
            </div>
    
    
    
        </section>
    
    
        <div v-if="showPopup" class="popup-overlay">
  <div class="popup-modal custom-gradient-blue-white">
    <img class="close-button" src="../assets/img/flyhigh/close.png" width="30px" @click="showPopup = false" />
    <CRow>
      <CCol sm="6">
        <CCard class="custom-card-white p-2">
          <img :src="selectedImage" style="max-width:100%" />
        </CCard>
      </CCol>
      <CCol sm="6">
        <div class="text-left">
          <h3 class="custom-32px-700">UCAPAN TAHNIAH</h3>
          <p class="custom-18px-400 text-white">Kejayaan Pelajar Fly High</p>

          <div class="custom-bg-transparent-blue">
            <h4 class="custom-16px-400 text-white text-left">
              Nama:<strong> {{ selectedName }}</strong><br />
              Pencapaian: <strong>{{ selectedExam }}</strong><br />
            <strong>  {{ selectedProgram }}</strong>
            </h4>
          </div>

          <br />
          <i class="mt-5">“{{ selectedQuote }}”</i>
        </div>
      </CCol>
    </CRow>
  </div>
</div>
        <Footer />
    </div>
</template>



<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

import _ from "lodash";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footer from '@/components/Footer.vue'


export default {
    name: "Login",
    components: {
        Mainlayout,
        Footer,


    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,
            showPopup: false,
            selectedImage: '',
            selectedText: '',
            selectedQuote: '',
            images: [
                { src: require('../assets/img/flyhigh/achieve1.png'), desc: 'Achievement 1', name: 'Aleef Arsyad bin Ahmad Kamel', exam: '9A', Program: 'Program Intensif UPKK Fly High:Jelajah UPKK, Gerak Gempur', quote: 'Terima kasih Ustaz Azhari (Abi) atas tunjuk ajar dan tips yang diberikan. Terima kasih Fly High menjadi platform untuk ramai anak-anak berjaya' },
                { src: require('../assets/img/flyhigh/achieve2.png'), desc: 'Achievement 2', name: 'Ahmad Adam Shah bin Ahmad Effendi', exam: '9A', Program: 'Program Intensif UPKK Fly High:Jelajah UPKK, Gerak Gempur', quote: 'Terima kasih yang tidak terhingga buat tenaga pengajar Fly High terutama Ustaz Azhari (Abi) dan Muallimah Hana yang banyak memberi tips dan cara menjawab soalan dengan betul mengikut skema jawapan. Terima kasih juga kepada team Fly High yang banyak membantu dalam urusan pemilihan kelas dan seminar yang dianjurkan sangat-sangat membantu, alhamdulillah.' },
                { src: require('../assets/img/flyhigh/achieve3.png'), desc: 'Achievement 3', name: 'Nur Adni Faqihah binti Mohd Arif', exam: '9A', Program: 'Program Intensif UPKK Fly High:Jelajah UPKK, Gerak Gempur',quote: 'Banyak pengetahuan dan ilmu yang anak saya perolehi untuk UPKK. Terima kasih FLY HIGH.' },
                { src: require('../assets/img/flyhigh/achieve4.png'), desc: 'Achievement 4', name: 'Thaqif Irfan bin Shahrizan', exam: '8A 1B', Program: 'Program Intensif UPKK Fly High:Jelajah UPKK, Gerak Gempur',quote: 'Alhamdulillah…Terima kasih Tuisyen UPKK FLYHIGH atas ilmu yang diberi oleh Ustaz. Doakan semakan semula result ‘B’ Jawi berjaya menukar gred itu. Anak telah berusaha bersungguh-sungguh dengan Flyhigh tetapi tidak tercapai result 9A. Hanya perlu redha.' },
                { src: require('../assets/img/flyhigh/achieve5.png'), desc: 'Achievement 5', name: 'Mya Maisara Yasmin binti Jamsari', exam: '', Program: 'Berjaya Terpilih(Sekolah Sains Kucing Sarawak)',quote: 'Terima kasih pada semua para guru, especially Cg Shahril, Cg Shukry, Sir Hazwan, Sir Koala, Cg Danial yang banyak bagi pengajaran dan tips yg sangat informatif dan bermanfaat. Semuanya sangat saya hargai dan terima kasih sangat sangat. Hantar anak ke FlyHigh sangat berbaloi dengan barisan cikgu-cikgu yg hebat' },
                { src: require('../assets/img/flyhigh/achieve6.png'), desc: 'Achievement 6', name: 'Shahirul Adzhar bin Zaillah', exam: '', Program:'Berjaya Terpilih(SM Sains Kucing Sarawak)', quote:'Alhamdulillah terima kasih Fly High terutamanya kepada Cg Shahril & Cg Bob atas segala tunjuk ajar dan ilmu yang diberikan. Semoga Fly High terus maju ke hadapan.' },
                { src: require('../assets/img/flyhigh/achieve7.png'), desc: 'Achievement 7', name: 'Syahir Amzar bin Mohd Syazwan', exam: '', Program:'Berjaya Terpilih(SM Sains Muzaffar Syah)',quote:'Alhamdulillah, Syahir Amzar berjaya diterima masuk ke MOZAC yg juga merupakan pilihan pertamanya. Terima kasih kepada warga pendidik dan pentadbiran FlyHigh atas segala tunjuk ajar dan informasi bermanfaat sepanjang tahun lepas. Moga FlyHigh terus maju dan teruskan usaha membantu anak-anak mencapai impian mereka ke sekolah-sekolah hebat dan terbaik di Malaysia.' },
                { src: require('../assets/img/flyhigh/achieve8.png'), desc: 'Achievement 8', name: 'Nurqaeira Khalisa Erina binti Khazrul Hislan', exam: '',  Program:'Berjaya Terpilih(Kolej Tunku Kurshiah)', quote: 'Jelajah UPKK, Gerak Gempur', quote: 'Terima kasih Fly High atas bimbingan yang luar biasa! Teknik yang mudah difahami serta sesi pembelajaran yang sangat interaktif benar-benar membantu anak kami dalam memahami dan menguasai teknik menjawab dengan betul. Ilmu serta tunjuk ajar yang diberikan sangat membantu. Semoga Fly High terus maju dan terus menjadi tempat bermanfaat kepada masa depan anak-anak!' },
                { src: require('../assets/img/flyhigh/achieve9.png'), desc: 'Achievement 9', name: 'Nur Naaz Syifa Binti Muhamad Shahril', exam: '',Program:'Berjaya Terpilih(MRSM(Program IGCSE,Kuala klawang,Negeri Sembilan))',quote:'Alhamdulillah. Ala kulli hal. Ribuan terima kasih buat pendidik-pendidik di Fly High Education Centre yang telah membantu Naaz Syifa dalam merealisasikan impiannya. Banyak ilmu dan tip dipelajari yg sangat memberi kesan yang cemerlang sepanjang proses perjuangan Naaz Syifa ketika itu. Guru-guru semua sentiasa dalam doa Naaz Syifa. Semoga Fly High Education terus maju dalam membantu melahirkan ‘kemenjadian’ murid yg diberkati Allah SWT.' },
                { src: require('../assets/img/flyhigh/achieve10.png'), desc: 'Achievement 10', name: 'Nur Aleesya Rania Bt Mohd Nazirin', exam: '', Program:'Berjaya Terpilih(SM Sains Banting)',quote:'Syukur alhamdulillah kerana terpilih di SBP dengan bantuan dan sokongan daripada Fly High dalam membuat persediaan menempuh pelbagai ujian PKSK dan PSRA (Mumtaz). Terima kasih Fly High teruskan cemerlang, gemilang dan terbilang.' },
                { src: require('../assets/img/flyhigh/achieve11.png'), desc: 'Achievement 11', name: 'Dhia Soffiya Binti Noredy Amin', exam: '',Program:'Berjaya Terpilih(MRSM Terendak)',quote:'Untuk persiapan ke MRSM/SBP perlu permulaan awal. Fly High adalah tempat pilihan untuk membuat persediaan tersebut.' },
                { src: require('../assets/img/flyhigh/achieve12.png'), desc: 'Achievement 12', name: 'Sheikh Muhammad Raees Bin Sheikh Mohd Syamil Hafiz', exam: '8A 1B', Program:'Program Intensif UPKK Fly High:Jelajah UPKK, Bengkel UPKK 2024',quote:'Di FlyHigh dpt belajar teknik menjawab soalan. Terima kasih Ustaz Azhari (Abi) & team Fly High.' }
            ]





        };

    },
    created() {
        AOS.init();

    },

    mounted() {



    },
    computed: {
  chunkedImages() {
    const chunkSize = 4;
    return this.images.reduce((acc, _, i) => {
      if (i % chunkSize === 0) acc.push(this.images.slice(i, i + chunkSize));
      return acc;
    }, []);
  }
},
    methods: {
        openPopup(img) {
            this.selectedImage = img.src;
    this.selectedText = img.desc;
    this.selectedName = img.name;
    this.selectedExam = img.exam;
    this.selectedQuote = img.quote;
    this.selectedProgram = img.Program;
    this.showPopup = true;
        }







    },

};
</script>
